import { Injectable, NgZone } from '@angular/core';
import {  URLSearchParams, Headers } from '@angular/http';
import { Router, NavigationExtras } from '@angular/router';
import { AUTH_CONSTANTS } from './auth-constants';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { HttpUtils } from '../../common/http/http-utils';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import { LocalStorageService } from 'ngx-webstorage';
import { CustomHttp } from '../../common/http/custom-http';
import { NspUpgradeService } from '../../publisher/src/publisher-ui/upgrade/nsp-upgrade.service';
import { Subscription } from 'rxjs';
import {environment} from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const _ = require('lodash');

@Injectable()
export class AuthService {

    public username = undefined;
    public isLoggedIn: boolean = false;
    public isLogInProgress: boolean = false;
    public isLogoutInProgress = false;
    public isLogoutComplete = false;
    public redirectUrl: string;
    public VREALM_TYPE = undefined;
    public PROVISIONING_LICENSES = undefined;
    public loggedInUserInfo: any;
    public subscribeHandler = undefined;
    public DPS_HEALTH = undefined;

    public endpointInfo = undefined;
    public isVCDGVRDepricated: boolean = false;
    public delegateAuthToVCD: boolean = false;
    public endpointType = null;

    private unAuthSubscriber: Subscription;

    private authChangeEventSubject: Subject<any> = new Subject<any>();
    private licenceChangeEventSubject: Subject<String> = new Subject<String>();
    private dpsHealthChangeEventSubject: Subject<String> = new Subject<String>();
    public authConstants = AUTH_CONSTANTS;

    private basicUserLoginResponse = null;
    private basicUserLoginUsername = null;
    private authChangeEventSubscription = null;

    constructor(public http: HttpClient, private router: Router, private localStorage: LocalStorageService, public nspUpgradeSvc: NspUpgradeService) {
        const me = this;
        this.unAuthSubscriber = CustomHttp.getunAuthorizedEvent().subscribe((res) => {
            if (res === 'LOGOUT_USER') {
                this.unAuthorizedLogout();
            }
        },
            (error) => { },
            () => { }
        );

        this.authChangeEventSubscription = this.authChangeEventSubject.subscribe((evt) => {
            if (evt === 'LOGIN_RESPONSE_RECEIVED') {
                const json = me.basicUserLoginResponse;
                let applianceVariant = (json && json.data && json.data.cloud && json.data.cloud.applianceVariant) || '';
                applianceVariant = applianceVariant.toUpperCase();
                if (applianceVariant === 'HCM_COMPLIANT' || applianceVariant === 'NSP_COMPLIANT') {
                    setTimeout(() => {
                        this.authChangeEventSubject.next('SHOW_GOVCLOUD_DISCLAIMER');
                    }, 2);
                } else {
                    this.processBasicUserLoginResponse(this.basicUserLoginUsername, this.basicUserLoginResponse);
                }
            }
        });
    }

    public cookieBasedLogin() {
        return this.http.get(HttpUtils.getBaseUrl() + '/hybridity/api/session')
            .map((res:any) => {
                this.isLoggedIn = true;
                const cloudType = (res.data && res.data.cloud && res.data.cloud.cloudType) ? res.data.cloud.cloudType : '';
                this.username = (res.data && res.data.user && res.data.user.userName) ? res.data.user.userName : '';
                this.loggedInUserInfo = (res.data && res.data.user) ? res.data.user : { roles: [] };
                if (cloudType === 'VCD') {
                    this.VREALM_TYPE = AUTH_CONSTANTS.VCD;
                } else if (cloudType === 'VC') {
                    this.VREALM_TYPE = AUTH_CONSTANTS.VC;
                } else if (cloudType === 'VIO') {
                    this.VREALM_TYPE = AUTH_CONSTANTS.VIO;
                }
                this.endpointInfo = (res.data && res.data.endpointInfo) ? res.data.endpointInfo : '';

                // Multitenancy is supported for VCD only.
                if (cloudType === 'VCD') {
                    // isVCDGVRDepricated variable will be used to control visibility of top menu items Dashboard and Inventory.
                    // It is also used to hide Network, Compute and DPS under "Services" tab.
                    // If "isVCDGVRDepricated" is not defined in session response, assume it is false.
                    this.isVCDGVRDepricated = res.data && res.data.cloud && res.data.cloud.isVCDGVRDepricated ? res.data.cloud.isVCDGVRDepricated : false;
                    this.delegateAuthToVCD = res.data && res.data.cloud && res.data.cloud.delegateAuthToVCD ? res.data.cloud.delegateAuthToVCD : false;
                }
                if (this.isVCDGVRDepricated) {
                    const roles = (this.loggedInUserInfo && this.loggedInUserInfo.roles) ? this.loggedInUserInfo.roles : [];
                    let redirect;
                    if (_.includes(roles, 'Organization Administrator')) {
                        // If this is a newVCDGVR, redirect org admin to /disaster-recovery-embed
                        redirect = '/disaster-recovery-embed';
                    } else if (_.includes(roles, 'System Administrator')) {
                        // If he is a System Admin, redirect him to administrator page.
                        redirect = '/administration';
                        if (this.delegateAuthToVCD) {
                            // If the authentication was delegated to VCD, then only change hte browser url.
                            window.top.location.href = window.self.location.href;
                        }
                    } else {
                        redirect = '/unauthorized';
                    }
                    this.router.navigate([redirect]);
                }

                if (cloudType === 'VIO') {
                    let roles = (this.loggedInUserInfo && this.loggedInUserInfo.roles) ? this.loggedInUserInfo.roles : [];
                    let redirect;
                    if (_.includes(roles, AUTH_CONSTANTS.OrgAdmin)) {
                        redirect = '/disaster-recovery-embed';
                    } else if(_.includes(roles, AUTH_CONSTANTS.SysAdmin)) {
                        redirect = '/administration';
                    } else {
                        redirect = '/unauthorized';
                    }
                    if (redirect) {
                        this.router.navigate([redirect]);
                    }
                }

                this.storeLoginUrl(this.VREALM_TYPE);

                if (this.isVCDGVRDepricated) {
                    // Change default route for services tab from 'compute' to 'disaster-recovery-embed' if it is newVCDGVR
                    this.changeServicesDefaultRoute();
                }
                this.setAuthChangeEvent('LOGIN_COMPLETE');
                this.getDpsHealth();
            }).catch(this.handleLoginError);
    }

    public basicUserLogin(username: string, password: string) {
        const sessionUrl = HttpUtils.getBaseUrl() + '/hybridity/api/sessions';
        let body = {
            'authType': 'password',
            'username': username,
            'password': password
        };

        let projectName = this.getProjectNameForCloud();
        if (projectName) {
            body['projectName'] = projectName;
        }
        return this.http.post(sessionUrl, body).map(
            (res) => {
                this.basicUserLoginUsername = username;
                this.basicUserLoginResponse = res;
                this.authChangeEventSubject.next('LOGIN_RESPONSE_RECEIVED');
            }
        ).catch(this.handleLoginError);
    }

    public processBasicUserLoginResponse(username: any, res: any) {
        this.isLoggedIn = true;
        this.loggedInUserInfo = (res.data && res.data.user) ? res.data.user : { roles: [] };
        this.username = username || this.loggedInUserInfo.username;
        const cloudType = (res.data && res.data.cloud && res.data.cloud.cloudType) ? res.data.cloud.cloudType : '';
        if (cloudType === 'VCD') {
            this.VREALM_TYPE = AUTH_CONSTANTS.VCD;
        } else if (cloudType === 'VC') {
            this.VREALM_TYPE = AUTH_CONSTANTS.VC;
        } else if (cloudType === 'VIO') {
            this.VREALM_TYPE = AUTH_CONSTANTS.VIO;
        }
        this.endpointInfo = (res.data && res.data.endpointInfo) ? res.data.endpointInfo : '';

        // Multitenancy is supported for VCD only.
        if (cloudType === 'VCD') {
            // isVCDGVRDepricated variable will be used to control visibility of top menu items Dashboard and Inventory.
            // It is also used to hide Network, Compute and DPS under "Services" tab.
            // If "isMultiTenant" is not defined in session response, assume it is false.
            this.isVCDGVRDepricated = res.data && res.data.cloud && res.data.cloud.isVCDGVRDepricated ? res.data.cloud.isVCDGVRDepricated : false;
            this.delegateAuthToVCD = res.data && res.data.cloud && res.data.cloud.delegateAuthToVCD ? res.data.cloud.delegateAuthToVCD : false;
        }

        this.setAuthChangeEvent('LOGIN_COMPLETE');
        this.getDpsHealth();
        let redirect;
        if (this.isVCDGVRDepricated) {
            const roles = (this.loggedInUserInfo && this.loggedInUserInfo.roles) ? this.loggedInUserInfo.roles : [];
            if (_.includes(roles, 'Organization Administrator')) {
                // If this is a newVCDGVR, redirect org admin to /disaster-recovery-embed
                redirect = '/disaster-recovery-embed';
            } else if (_.includes(roles, 'System Administrator')) {
                // If he is a System Admin, redirect him to administrator page.
                redirect = '/administration';
                if (this.delegateAuthToVCD) {
                    // If the authentication was delegated to VCD, then only change hte browser url.
                    window.top.location.href = window.self.location.href;
                }
            } else {
                redirect = '/unauthorized';
            }
            // Change default route for services tab from 'compute' to 'disaster-recovery-embed' if it is newVCDGVR
            this.changeServicesDefaultRoute();
            const navigationExtras: NavigationExtras = {
                preserveQueryParams: true,
                preserveFragment: true
            };
            this.storeLoginUrl(this.VREALM_TYPE);
            if (redirect) {
                this.router.navigate([redirect], navigationExtras);
            }
        } else {
            const me = this;
            this.nspUpgradeSvc.queryHcmInstances(
                () => {
                    setTimeout(() => {
                        me.initApplication();
                    }, 10);
                }, null);
        }

        if (cloudType === 'VIO') {
            let roles = (this.loggedInUserInfo && this.loggedInUserInfo.roles) ? this.loggedInUserInfo.roles : [];
            if (_.includes(roles, AUTH_CONSTANTS.OrgAdmin)) {
                redirect = '/services/disaster-recovery-embed';
            } else if(_.includes(roles, AUTH_CONSTANTS.SysAdmin)) {
                redirect = '/administration';
            } else {
                redirect = '/unauthorized';
            }
            this.changeServicesDefaultRoute();
        }

        let navigationExtras: NavigationExtras = {
            preserveQueryParams: true,
            preserveFragment: true
        };
        this.storeLoginUrl(this.VREALM_TYPE);
        if (redirect) {
            this.router.navigate([redirect], navigationExtras);
        }
    }

    public vcSessionBasedLogin(errorHandler) {
        const htmlClientSdk = environment.htmlClientSdk;
        if (htmlClientSdk) {
            htmlClientSdk.initialize(() => {
                htmlClientSdk.app.getSessionInfo((sessionInfo: any) => {
                    console.log('VC UI session info collected');
                    const sessionRequest = {
                        'authType': 'vmware-api-session-id',
                    };
                    
                    const sessionUrl = `${HttpUtils.getBaseUrl()}/hybridity/api/sessions`;
                    this.http.post(sessionUrl, sessionRequest, {
                        headers: new HttpHeaders({
                            'x-psid-authorization': sessionInfo.sessionToken
                        })
                    })
                    .subscribe((response) => {
                        console.log('HCX Login successful with PSID');
                        this.processBasicUserLoginResponse(null, response);
                        this.isLogInProgress = false;
                    }, error => {
                        this.isLogInProgress = false;
                        console.error('error in authenticating at HCX');
                        errorHandler && errorHandler(error);
                    });
                });
            });
        } else {
            console.error("failed to load VC htmlSdk for remote plugin");
            this.isLogInProgress = false;
            errorHandler && errorHandler("failed to load VC htmlSdk for remote plugin. Try reloading the page again by clicking refresh button of browser.");
        }
    }

    public storeLoginUrl(cloudType: string): void {
        localStorage.setItem('cloudType', cloudType);
        // Store login url only when it is VCD and authentication is delegated to VCD.
        if (cloudType === AUTH_CONSTANTS.VCD && this.delegateAuthToVCD) {
            let paramString = window.location.search;
            paramString = paramString.substring(paramString.indexOf('?') + 1);
            const params = new URLSearchParams(paramString);
            const orgName = params.get('orgName');
            let logoutUrl;
            const url = document.createElement('a');
            url.href = window.location.href;
            const logoutUrlPrefix = url.protocol + '//' + url.host;
            if (orgName !== null) {
                logoutUrl = logoutUrlPrefix + '/cloud/org/' + orgName + '/login.jsp';
            } else {
                // System admin will not have orgName in the url.
                // So the logout url is <hostname>/cloud
                logoutUrl = logoutUrlPrefix + '/cloud';
            }
            localStorage.setItem('logoutUrl', logoutUrl);
        } else if (cloudType === AUTH_CONSTANTS.VIO) {
            let paramString = window.location.search;
            paramString = paramString.substring(paramString.indexOf('?') + 1);
            let params = new URLSearchParams(paramString);
            let projectName = params.get('project');
            let logoutUrl: string;
            let url = document.createElement('a');
            url.href = window.location.href;
            let logoutUrlPrefix = url.protocol + '//' + url.host;
            if (projectName) {
                logoutUrl = logoutUrlPrefix + '/hybridity/project/' + projectName;
            } else {
                logoutUrl = logoutUrlPrefix;
            }
            localStorage.setItem('logoutUrl', logoutUrl);
        }
    }

    public unAuthorizedLogout() {
        // This is called to when we get a 401 error on any HTTP calls.
        console.log('unAuthorizedLogout - redirect to logut page');
        this.router.navigate(['/logout']);
        this.setAuthChangeEvent('LOGOUT_TRIGGERED');
        this.isLoggedIn = false;
        //  unset previous logged in user info 
        this.loggedInUserInfo = null;
        this.isLogoutInProgress = false;
        this.isLogoutComplete = true;
        this.redirectToLoginPage(true);
    }

    public logout() {
        console.log('logout - redirect to logut page');
        this.router.navigate(['/logout']);
        this.isLogoutInProgress = true;
        this.isLogoutComplete = false;
        const me = this;
        console.log('logout - start call DELETE /hybridity/api/session');
        this.http.delete(HttpUtils.getBaseUrl() + '/hybridity/api/session').subscribe(
            (res: any) => {
                console.log('logout - completed call DELETE /hybridity/api/session: ' + res.ok);
                me.setAuthChangeEvent('LOGOUT_TRIGGERED');
                me.isLoggedIn = false;
                me.isLogoutInProgress = false;
                me.isLogoutComplete = true;
                me.redirectToLoginPage(false);
            },
            (error: any) => {
                console.error('logout - error call DELETE /hybridity/api/session: ' + JSON.stringify(error));
                me.handleLogoutError(error);
            },
            () => {console.log('logout - delete session async promise completed'); }
        );
    }

    public redirectToLoginPage(useRouter) {
        const cloudType = localStorage.getItem('cloudType');
        let logoutUrl = localStorage.getItem('logoutUrl');
        localStorage.clear();
        sessionStorage.clear();
        if (cloudType && logoutUrl) {
            if (cloudType === AUTH_CONSTANTS.VCD) {
                console.log('redirectToLoginPage VCD:' + logoutUrl);
                window.location.href = logoutUrl;
            } else if (cloudType === AUTH_CONSTANTS.VC) {
                console.log('redirectToLoginPage:' + '/login');
                this.router.navigate(['/login']);
            } else if (cloudType === AUTH_CONSTANTS.VIO) {
                console.log('redirectToLoginPage VIO:' + logoutUrl);
                window.location.href = logoutUrl;
            }
        } else {
            // We reconstuct the logout url if we don't have cloud type or logout url info.
            let paramString = window.location.search;
            if (paramString.indexOf('orgName') !== -1) {
                // If URL contains 'orgName' string, cloud type is VCD.
                paramString = paramString.substring(paramString.indexOf('?') + 1);
                const params = new URLSearchParams(paramString);
                const orgName = params.get('orgName');
                const url = document.createElement('a');
                url.href = window.location.href;
                logoutUrl = url.protocol + '//' + url.host + '/cloud/org/' + orgName + '/login.jsp';
                console.log('redirectToLoginPage: VCD ORG' + logoutUrl);
                window.location.href = logoutUrl;
            } else if (paramString.indexOf('project') !== -1) {
                this.router.navigate(['/login']);
            } else {
                if (useRouter) {
                    this.router.navigate(['/login']);
                } else {
                    // hack because router to login after logout does not work with app.html main outer-outlet
                    const loginUrl = window.location.href.substr(0, window.location.href.indexOf('#')) + '#/login';
                    console.log('redirectToLoginPage loginUrl:' + loginUrl);
                    window.location.href = loginUrl;
                    // this.router.navigate(['/login']); // shows up in browser but does not load
                    window.location.reload(); // ... so force reload here

                    //window.location.hash = '#login';
                    //location.reload();
                }
            }
        }
    }

    public setAuthChangeEvent(event: string): void {
        this.authChangeEventSubject.next(event);
    }

    public getAuthChangeEvent(): Observable<any> {
        return this.authChangeEventSubject.asObservable();
    }

    public getProvisioningLicenses(): void {
        this.subscribeHandler = this.http.get(HttpUtils.getBaseUrl() + '/hybridity/api/provisioning/licenses')
            .map((res) => {
                return res;
            }).catch(this.handleLicenceError)
            .subscribe(
                (res) => {
                    this.PROVISIONING_LICENSES = res;
                    this.setLicenceChangeEvent(this.PROVISIONING_LICENSES);
                },
                (error) => {
                    this.PROVISIONING_LICENSES = undefined;
                    this.setLicenceChangeEvent(undefined);
                },
                () => {
                    if (this.subscribeHandler) { this.subscribeHandler.unsubscribe(); }
                }
            );
    }

    public setLicenceChangeEvent(licences: any): void {
        this.PROVISIONING_LICENSES = licences;
        this.licenceChangeEventSubject.next(licences);
    }

    public getLicenceChangeEvent(): Observable<any> {
        return this.licenceChangeEventSubject.asObservable();
    }

    private handleLogoutError(error: any) {
        const errMsg = (error.message) ?
            error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        this.isLogoutInProgress = false;
        this.isLogoutComplete = false;
        return Observable.throw(errMsg);
    }

    private handleLoginError(error: any) {
        const errMsg = (error.error) ?
            error.error : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        this.isLoggedIn = false;
        console.error('handleLoginError: ' + errMsg);
        return Observable.throw(errMsg);
    }

    private handleLicenceError(error: any) {
        return Observable.throw('License Error' + error);
    }

    // tslint:disable-next-line:member-ordering
    public getDpsHealth(): void {
        this.subscribeHandler = this.http.get(HttpUtils.getBaseUrl() + '/hybridity/api/dps/health')
            .map((res) => {
                return res;
            }).catch(this.handleDpsHealthError)
            .subscribe(
                (res) => {
                    this.DPS_HEALTH = res;
                    this.setDpsHealthChangeEvent(this.DPS_HEALTH);
                },
                (error) => {
                    this.DPS_HEALTH = undefined;
                    this.setDpsHealthChangeEvent(undefined);
                },
                () => {
                    if (this.subscribeHandler) { this.subscribeHandler.unsubscribe(); }
                }
            );
    }

    // tslint:disable-next-line:member-ordering
    public setDpsHealthChangeEvent(health: any): void {
        this.DPS_HEALTH = health;
        this.dpsHealthChangeEventSubject.next(health);
    }

    // tslint:disable-next-line:member-ordering
    public getDpsHealthChangeEvent(): Observable<any> {
        return this.dpsHealthChangeEventSubject.asObservable();
    }

    private handleDpsHealthError(error: any) {
        return Observable.throw('Dps health check error' + error);
    }

    private changeServicesDefaultRoute() {
        // First get all routes of services with children.
        const servicesRoutes = (this.router.config.filter((x) => (x.path === 'services' && (x.children && x.children.length > 0))))[0];
        const childrenRoutes = servicesRoutes.children;
        const defaultRoute = childrenRoutes.filter((x) => x.path === '')[0];
        // Set its redirectTo to "disaster-recovery-embed"
        defaultRoute.redirectTo = 'disaster-recovery-embed';
    }

    // tslint:disable-next-line:member-ordering
    public getLocalHcmEndpoint() {
        return this.nspUpgradeSvc.getLocalHcmReference();
    }

    // tslint:disable-next-line:member-ordering
    public initApplication() {
        const localEndpoint = this.getLocalHcmEndpoint();
        this.endpointType = localEndpoint != null ? localEndpoint.endpoint != null ? localEndpoint.endpoint.endpointType : null : null;
        let redirect;
        if (this.isFeatureEnabled('GVR_DASHBOARD_VIEW', 'VISIBLE')) {
            redirect = this.redirectUrl ? this.redirectUrl : '/dashboard';
        } else if (this.isFeatureEnabled('HCSP_DASHBOARD_VIEW', 'VISIBLE')) {
            redirect = this.redirectUrl ? this.redirectUrl : '/dashboard-hcsp';
        }

        const navigationExtras: NavigationExtras = {
            preserveQueryParams: true,
            preserveFragment: true
        };
        this.storeLoginUrl(this.VREALM_TYPE);
        if (redirect) {
            this.router.navigate([redirect], navigationExtras);
        }
        
    }

    // TODO update to use featureConfig API - This is only for DEMO of HCX Onprem SA 2/2019
    // tslint:disable-next-line:member-ordering
    public isFeatureEnabled(feature: string, operation: string): boolean {
        if (feature === 'GVR_DASHBOARD_VIEW') {
            if (operation === 'VISIBLE') {
                return this.endpointType === 'nsp' && this.VREALM_TYPE !== this.authConstants.VIO;
            }
        } else if (feature === 'HCSP_DASHBOARD_VIEW') {
            if (operation === 'VISIBLE') {
                return this.endpointType === 'hcm';
            }
        } else if (feature === 'SITE_PAIRING_VIEW') { // 'PAIRING' with featureConfig API... so this is not needed !
            if (operation === 'VISIBLE') {
                return this.endpointType === 'hcm';
            }
        }
        return false;
    }

    getEndpointInfo() {
        return this.http
            .get(HttpUtils.getBaseUrl() + '/hybridity/api/endpointInfo')
    }

    getProjectNameForCloud() { // ?project=sampleProject#/login
        let paramString = window.location.search;
        paramString = paramString.substring(paramString.indexOf('?') + 1);
        let params = new URLSearchParams(paramString);
        return params.get('project');
    }

    public onGovCloudAgreeClicked() {
        this.processBasicUserLoginResponse(this.basicUserLoginUsername, this.basicUserLoginResponse);
    }

}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts